<!--
    微信绑定到账号
    用户成功获取 code、openid 后，后台会重定向到这个页面。发起请求处可以设置一个 state 参数，里面存储了 自定义数据。
    此组件功能：能跳到此页面说明后台认证已成功，这里只负责解析 state 内容，检查是否需要显示绑定用户表单，将当前微信号与账号绑定。
-->
<template>
  <section class="weixin-login">
    <div style="text-align:center;margin:20px 0 10px 0;">
      <div style="align-items:center;justify-content:center;">
        <img v-if="headimgurl" v-bind:src="headimgurl" alt=""
             style="width:60px;margin-bottom:15px;border-radius:5px;-webkit-border-radius:5px;">
        <h3 style="margin:0;">账号绑定</h3>
      </div>
      <p style="margin:20px 0 25px 0;color:#333">首次微信登录请绑定会员账号</p>
    </div>
    <b-form inline>
      <div style="width:100%;">
        <div class="form-group">
          <b-input-group v-bind:prepend="nationCode">
            <b-form-input type="number" id="inline-form-input-name" v-bind:placeholder="phonePlaceholder"
                          v-model="phone" autocomplete="off">
            </b-form-input>
          </b-input-group>
        </div>
        <div class="form-group">
          <b-input-group>
            <b-form-input type="password" id="password" v-model="password" placeholder="密码" autocomplete="off">
            </b-form-input>
          </b-input-group>
        </div>

        <div class="form-bottom">
          <a class="login-cancle-btn" href="/" variant="primary">取消</a>
          <b-button class="login" variant="primary" v-on:click="login">{{ loginText }}</b-button>
        </div>

        <p class="msg-group" v-html="msg"></p>
      </div>
    </b-form>
  </section>
</template>

<script>
import RegexToolbox from '../utils/regex.toolbox'
import Server from "../utils/server";
import common from "@/utils/common";

export default {
  name: 'WeixinLogin',
  data() {
    return {
      imageUrl: '',
      nationCode: '+86',
      phone: '',
      password: '',
      msg: '',
      loginText: '确定',

      headimgurl: '/images/login/account-binding.png',
      nickname: '',
      unionid: ''
    };
  },
  computed: {
    phonePlaceholder() {
      common.setSeoFooterElementVisible(false)
      return '手机号';
    }
  },
  setup() {
  },
  created() {  // 模板渲染成html前调用
    if (document.getElementById('home')) document.getElementById('home').style.display = 'none';
  },
  mounted() {  // 模板渲染成html后调用
    this.$root.$refs.RouteMenu.hideMe();
    this.msg = '';

    var paramMap = {}
    var q = decodeURIComponent(window.location.search.substring(1))
    var params = q.split("&");
    for (var i = 0; i < params.length; i++) {
      var arr = params[i].split("=");
      paramMap[arr[0]] = arr[1]
    }
    this.headimgurl = paramMap['headimgurl']
    this.nickname = paramMap['nickname']
    this.unionid = paramMap['unionid']
    var sessionId = paramMap['sessionId']

    // 检查当前页面是否被嵌套在 iframe 中
    if (window.top !== window.self) {
      // 如果当前页面被嵌套在 iframe 中，则让父窗口跳转到指定 URL
      if (sessionId) {
        this.LocalStorage.saveLoginUser({"sessionId": sessionId});
        window.top.location.href = '/'
      } else {
        window.top.location.href = location.href
      }
    }
  },
  updated() {
  },
  components: {},
  methods: {
    login: function () {
      this.msg = '';
      if (!this.phone || this.phone.length === 0) {
        this.msg = '请输入账号';
        return;
      }
      if (!RegexToolbox.isPhoneLiteralLikely(this.phone) && !RegexToolbox.isTeamMemberLiteral(this.phone)) {
        this.msg = '账号格式错误';
        return;
      }
      if (!this.password || this.password.length === 0) {
        this.msg = '密码不能为空';
        return;
      }
      if (this.password.length < 6) {
        this.msg = '密码太短，至少6位数';
        return;
      }
      if (!this.unionid || this.unionid.length === 0) {
        this.msg = '微信信息丢失';
        return;
      }

      this.loginAjax()
    },
    loginAjax: function () {
      const self = this;
      if (this.loginText === '绑定中') return;

      this.msg = '';
      this.loginText = '绑定中';

      const loginReq = {
        username: this.phone,
        password: this.password,
        unionid: this.unionid
      };

      setTimeout(function () {
        const url = Server.getCloudServiceAddress() + '/account/bindWechat';
        const resp = self.Ajax.post(url, loginReq, false, '', '', '', '');
        self.loginText = '确定';

        if (resp.success) {
          const simpleUserDto = resp.data[0];
          if (simpleUserDto) {
            let sessionId = simpleUserDto.sessionId
            if (sessionId) {
              self.LocalStorage.saveLoginUser({"sessionId": sessionId});
              location.href = '/'
            }
          } else {
            self.msg = Server.getAjaxResponseMessage(resp);
          }
        } else {
          self.msg = Server.getAjaxResponseMessage(resp);
        }
      }, 500);
    }
  }
}

</script>

<style lang="scss" scoped>

.form-group {
  width: 100%;

  input {
    height: 45px;
  }
}

.form-inline .form-group {
  margin-bottom: 10px;
}

.input-group-text {
  background-color: transparent;
}

.form-inline .custom-select, .form-inline .input-group {
  width: 100%;
}

.weixin-login {
  margin: 0 auto;
  background: #fff;
  display: block;
  flex-shrink: 0;

  width: 100%;
  border: none;
  margin-top: 25%;
  padding: 20px 20px 21px;
}

.form-bottom {
  width: 100%;
  margin-top: 15px;

  .login-cancle-btn {
    float: left;
    color: #1a73e8;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    position: relative;
    top: 8px;
  }

  .login-cancle-btn:hover {
    color: #135ab6;
  }

  .login {
    float: right;
    cursor: pointer;
    padding: 5px 30px;
  }

}

.msg-group {
  width: 100%;
  height: 2em;
  font-size: 13px;
  color: #dc3545;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  padding-top: 8px;
  margin-bottom: 0;
  text-align: center;
}

/*去掉input[type="number"]的默认样式*/
//-----------------------------------

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

input[type="number"] {
  -moz-appearance: textfield;
}

//-----------------------------------

@media only screen and (min-width: 576px) {
  .weixin-login {
    width: 340px;
    border: 1px solid #dadce0;
    border-radius: 8px;
    margin-top: 120px;
    padding: 33px 40px 18px;
  }

  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 10px;
  }
}

</style>
